import { appConfig, headerConfig, refineHeader } from "../../config";

export const voucherService = {
  add_voucher,
  getdealForVoucher,
  getVoucherList,
  redeem_voucher,
  checkEmail,
  renderAutoEmail,
  checkQuantity,
  updateStatus,
  getMerchantDeals,
  getMerchantVoucherList,
  getVoucherDetail,
  edit_voucher,
  upload_TrackingNumbers,
  getUploadTrackingHistory,
  export_PurchaserList,
  voucherTransfer,
  refundVoucher,
  getOrderHistory,
  resendVoucher,
};

function getOrderHistory(formData) {
  refineHeader();

  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    body: JSON.stringify(formData)
  };
  return fetch(`${appConfig.api.url}voucher/user-offers`, requestOptions)
    .then(handleResponse)
    .then(orderdata => {
      return orderdata;
    });
}

function add_voucher(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}voucher/generateVoucher`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function upload_TrackingNumbers(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerImage,
    mode: "cors",
    body: postData
  };

  return fetch(
    `${appConfig.api.url}voucher/upload-tracking-number`,
    requestOptions
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function edit_voucher(postData) {
  refineHeader();
  const requestOptions = {
    method: "PUT",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  var urltype = '';
  if(localStorage.userTypeName == "merchant"){
    urltype = "voucher/merchant-edit";
  }else{
    urltype = "voucher/edit";
  }

  

  return fetch(`${appConfig.api.url}`+ urltype, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getdealForVoucher(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}deal/dealForVoucher`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getMerchantDeals(userID) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify()
  };

  return fetch(
    `${appConfig.api.url}deal/merchant-deal-list/${userID}`,
    requestOptions
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getVoucherList(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}voucher/list`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getMerchantVoucherList(dealID) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(dealID)
  };

  return fetch(`${appConfig.api.url}voucher/deal-voucher`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function checkEmail(emailID) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(emailID)
  };

  return fetch(`${appConfig.api.url}check_email`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function redeem_voucher(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}voucher/redeemVoucher`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function renderAutoEmail(emailtext) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(emailtext)
  };

  return fetch(`${appConfig.api.url}user/auto-email`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function checkQuantity(qty) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(qty)
  };

  return fetch(`${appConfig.api.url}voucher/checkQuantity`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function updateStatus(voucherID, status) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(status)
  };

  return fetch(
    `${appConfig.api.url}voucher/voucherStatus/${voucherID}`,
    requestOptions
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getVoucherDetail(voucherID, siteID) {
  //refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas,
    mode: "cors"
  };

  return fetch(
    `${appConfig.api.url}voucher/detail/${voucherID}/${siteID}`,
    requestOptions
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getUploadTrackingHistory() {
  //refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas,
    mode: "cors"
  };

  return fetch(
    `${appConfig.api.url}voucher/tracking-file-upload-history`,
    requestOptions
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function export_PurchaserList(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(
    `${appConfig.api.url}voucher/export-purchaser-list`,
    requestOptions
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function voucherTransfer(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}voucher/transafer-voucher`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function refundVoucher(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}payment/refund-payment`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function resendVoucher(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}voucher/resend-voucher`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}



// WEBPACK FOOTER //
// ./src/app/services/API/voucherService.js